/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * Enum for VoteType
 * @public
 */
export var VoteType;
(function (VoteType) {
  VoteType["NONE"] = "NONE";
  VoteType["UP"] = "UP";
  VoteType["DOWN"] = "DOWN";
})(VoteType || (VoteType = {}));